import { render, staticRenderFns } from "./contract_management_info.vue?vue&type=template&id=b585069e&scoped=true"
import script from "./contract_management_info.vue?vue&type=script&lang=js"
export * from "./contract_management_info.vue?vue&type=script&lang=js"
import style0 from "./contract_management_info.vue?vue&type=style&index=0&id=b585069e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b585069e",
  null
  
)

export default component.exports